

import ameMenu from './Menus/AmeMenu';
import apMenu from './Menus/ApMenu';
import arMenu from './Menus/ArMenu';
import fassetsMenu from './Menus/FAssetsMenu';
import financeMenu from './Menus/FinanceMenu';
import fleetMenu from './Menus/FleetMenu';
import hrMenu from './Menus/HrMenu';
import integrationMenu from './Menus/IntegrationMenu';
import inventoryMenu from './Menus/InventoryMenu';
import notificationsMenu from './Menus/NotificationsMenu';
import ntxMenu from './Menus/NtxMenu';
import payrollMenu from './Menus/PayrollMenu';
import posMenu from './Menus/PosMenu';
import purchasesMenu from './Menus/PurchasesMenu';
import raqeebMenu from './Menus/RaqeebMenu';
import reportsMenu from './Menus/ReportsMenu';
import salesMenu from './Menus/SalesMenu';
import suMenu from './Menus/SuMenu';
import userMenu from './Menus/UserMenu';
import mrpMenu from './Menus/MrpMenu';
import projectsMenu from './Menus/projectMenu';
import CashMenu from './Menus/CashMenu';


const Menu = [
  ...ntxMenu,  
  ...userMenu,
  ...payrollMenu,
  ...raqeebMenu,
  ...ameMenu,
  ...hrMenu,
  ...fassetsMenu,
  ...apMenu,
  ...arMenu,
  ...reportsMenu,
  ...suMenu,
  ...fleetMenu,
  ...notificationsMenu,
  ...financeMenu,
  ...integrationMenu,
  ...CashMenu,
  ...salesMenu,
  ...inventoryMenu,
  ...purchasesMenu,
  ...posMenu,
  ...mrpMenu,
  ...projectsMenu,
];


// const Menu = [
//   { is_header: true, title: 'Navigation' },
//   { path: '/', icon: 'fa fa-home', title: 'Home' },
//   { path: '/login', icon: 'fa fa-home', title: 'Login' }
// ];

export default Menu;
